<script>
  // chats are associated with a TetradId and you must signed in to participate
  import { FirebaseApp, Doc, Collection, User } from "sveltefire";
  import firebase from "firebase/app";
  export let suggestion = "";
  let text;
  import { d, e, f, i, k, o, r, s, w, showModal} from './stores.js';
  import {getContext} from 'svelte';
  const db = getContext('firebase').firestore();
  const messagesRef=db.collection("messages");
  export let tetradId=0
  let user;
  let tetradDoc=db.collection("tetrads").doc(tetradId);
  
  //------- chat database crud
  import { onMount } from 'svelte';
  let messages=[{whomFromName: "Welcome", i: "everyone", message: "to Global Village Day" }];

  if (tetradId == 0){
    onMount(async () => {
      messagesRef
      .onSnapshot(function(snapshot){
          snapshot.docChanges().forEach(function(change){
            if (change.type === "added"){
              messages = [...messages, change.doc.data()];
            }
          })
        
      })
    });
  } else {
    onMount(async () => {
      messagesRef.where("chatroomId", "==", tetradId)
      .onSnapshot(function(snapshot){
          snapshot.docChanges().forEach(function(change){
            if (change.type === "added"){
              messages = [...messages, change.doc.data()];
            }
          })
        
      })
    });
  }

  function updateTetrad (obj){  //{e: y}
    tetradDoc.update(obj)   
    .then(function() {console.log("Document successfully updated!");})
    .catch(function(error) {
        // The document probably doesn't exist.
        console.error("Error updating document: ", error);
    });
  }

  function handleButton(user){
    //all inputs added to log except ? or help
    let x=text.toLowerCase().trim();
    if (x==="?" || x==="help" || x.length==0){
      // alert('pop up help')
      showModal.set(true)
    } else {
      //see if starts with :r, :o, :e, :f etc
      //command mode
      let command="";
      if (x.substring(0,1)===":") {
        command=x.substring(1,2);
      } else if (x.substring(1,2)===":"){
        command=x.substring(0,1);
      }
      if (command.length>0 && !($k == true)){ 
        let y=text.substring(3).trim();
        //alert("k="+$k+"  command="+command+"  y="+y);
        switch (command) {
          case 'e':
            e.set(y);
            updateTetrad({e: y})
            break;
          case 'f':
            f.set(y);
            updateTetrad({f: y})
            break;
          case 'o':
            o.set(y);
            updateTetrad({o: y})
            break;
          case 'r':
            r.set(y);
            updateTetrad({r: y})
            break;
          case 'i':
            i.set(y);
            updateTetrad({i: y})
            break;
          case 's':
            s.set(y);
            updateTetrad({s: y})
            break;
          case 'd':
            d.set(y);
            updateTetrad({d: y})
            break;
          case 'w':
            w.set(y);
            updateTetrad({w: y})
            break;
          default:
            console.log('Sorry, no command for that yet: '+x.substring(1,2));
        }
      }
      console.log("command="+command+"  k="+$k)
      if (command.length>0 && ($k == true)){ 
        alert("No commands allowed. This tetrad is locked")
      } else{
        message2cloud(user);
      }
      text = "";
    }
  }

  $: if (suggestion.length != 0){
    text = suggestion;
    handleButton(user);
  } 



  function message2cloud(user){
    let x={};
    x.chatroomId=tetradId;
    x.message=text;
    x.i=$i;
    x.whenCreated = new Date().getTime().toString();
    x.whomFromId = user.uid;
    x.whomFromName = user.displayName;
    // save into database
    messagesRef.doc(x.whenCreated).set(x)
  }

</script>

<FirebaseApp {firebase}>
  <div class="chat">
    <div class="messages">
      {#each messages as message, index}
        <div class="full">
        <span class="whom">{message.whomFromName}</span>
        {#if tetradId == 0}
          <span class="i">({message.i})</span>
        {/if}
        <span class="text">{message.message}</span></div>
      {/each}
    </div>
<!-- <h1>K</h1>
<p>{k} {$k}</p> -->


    <User let:user let:auth>
      <div class="chatInput">
        <!-- <input bind:value={text} size="60" placeholder="type here, ? for help"
        on:keyup={e=>e.key==='Enter' && handleButton(user)}/> -->
        <textarea class="txarea" bind:value={text} placeholder="type here, ? for help"
        on:keyup={e=>e.key==='Enter' && handleButton(user)} rows="4" cols="35"></textarea>
        <br>
        <button on:click={() => handleButton(user) }>Submit</button>
      </div>
    </User>
    <!-- <p>SUGGESTION: {suggestion}</p> -->
  </div>
</FirebaseApp>

<style>
  .chatInput {margin-top: 1rem; padding: 0.4rem;}
  .whom, .i {color: grey;}
  .full {padding: 0.4rem;}
  .txarea {resize: vertical}
  .messages>div:nth-child(even){background-color:white;}
  .messages>div:nth-child(odd){background-color: gainsboro;}
</style>

